import React from 'react';
import { Paper } from '@material-ui/core';

class About extends React.Component {
  render() {
    return(
      <div>
        <h1>LEO XIA</h1>
        <Paper variant="outlined">
        </Paper>
      </div>
    )
  }
}

export default About;
